import React from 'react'
import { createRoot } from 'react-dom/client'
import { Xyz3D } from './components/Xyz3D'
import './styles.css'
import { WatermarkOverlay, initWatermarkProtection } from '@webcrafter/common/watermark'

// Initialize protection if enabled
if (typeof __WEBCRAFTER_WATERMARKED__ !== 'undefined' && __WEBCRAFTER_WATERMARKED__) {
  initWatermarkProtection()
}

function App() {
  return (
    <>
      {typeof __WEBCRAFTER_WATERMARKED__ !== 'undefined' && __WEBCRAFTER_WATERMARKED__ && <WatermarkOverlay />}
      <Xyz3D />
    </>
  )
}

const root = createRoot(document.getElementById('root'))
root.render(<App />)
